/* ONF-CUSTOM-START :: alpha_judgeme
 * Koerpergroesse der Bewerter direkt auf die Bewertungskarten.
 *
 * In Judge.me gibt es die benutzerdefinierte Frage "Koerpergroesse". Judge.me
 * zeigt die Antwort bestenfalls klein irgendwo in der Karte (Produktseite) oder
 * gar nicht (Karussell auf der Startseite, dort erst im Popup). Fuer uns ist
 * die Groesse aber das Wichtigste an einer Bewertung - also ein eigenes,
 * gut sichtbares Feld ueber den Sternen: "Koerpergroesse: 1,90 m".
 *
 * Woher kommt die Antwort?
 * - Startseiten-Karussell: Judge.me laedt die Bewertungen per fetch von
 *   ".../reviews/reviews_for_carousel?..." - jede Bewertung hat dort
 *   cf_answers. Wir holen dieselbe URL noch mal (kommt aus dem Browser-Cache)
 *   und ordnen ueber data-review-id (= uuid) den Karten zu.
 * - Produktseite: Judge.me rendert die Antworten fertig ins HTML
 *   (.jm-custom-answers). Wir suchen dort den Eintrag zur Koerpergroesse,
 *   setzen ihn als Feld ueber die Sterne und blenden das Original aus.
 *
 * Ausserdem: Auf der Produktseite werden die Bewertungen ein Slider statt
 * Seiten (siehe "Slider statt Seiten" unten), und Produkt-URL +
 * #bewertung-schreiben oeffnet direkt das Bewertungsformular.
 *
 * Beide Widgets bauen sich nachtraeglich (und beim Blaettern/Sortieren neu)
 * auf, daher MutationObserver statt einmaligem Durchlauf.
 */
(function () {
  if (window.alphaJudgeme) return;

  var LABEL = 'Körpergröße';
  // Fragetitel, die eindeutig die Koerpergroesse meinen
  var QUESTION_STRICT = /k(ö|oe|o)rpergr(ö|oe|o)(ß|ss|s)e|body\s*height|^\s*height\b|wie\s+gro(ß|ss)\s+bist/i;
  // "Groesse" allein kann auch die Kleidergroesse sein - nur mit plausiblem Wert
  var QUESTION_LOOSE = /gr(ö|oe|o)(ß|ss|s)e|height/i;

  var heights = {}; // uuid -> Antworttext (Startseite)

  /* ---------- Wert lesbar machen: 190 / 190cm / 1.90 -> "1,90 m" ---------- */
  function toMeters(num) {
    var n = parseFloat(String(num).replace(',', '.'));
    if (isNaN(n)) return null;
    if (n >= 140 && n <= 250) n = n / 100; // Zentimeter
    if (n < 1.4 || n > 2.5) return null;
    return n.toFixed(2).replace('.', ',');
  }

  function formatHeight(raw) {
    var text = String(raw || '').trim();
    if (!text) return null;
    // Bereich wie "190-195 cm" oder "1,90 - 1,95 m"
    var range = text.match(/^(\d+(?:[.,]\d+)?)\s*(?:cm|m)?\s*[-–bis]+\s*(\d+(?:[.,]\d+)?)\s*(cm|m)?\.?$/i);
    if (range) {
      var a = toMeters(range[1]);
      var b = toMeters(range[2]);
      if (a && b) return a + '–' + b + ' m';
    }
    var single = text.match(/^(?:ca\.?\s*)?(\d+(?:[.,]\d+)?)\s*(cm|m)?\.?$/i);
    if (single) {
      var m = toMeters(single[1]);
      if (m) return m + ' m';
    }
    // "über 2,10 m", "unter 1,90" usw.: so lassen wie eingegeben
    return text.length <= 30 ? text : null;
  }

  function isPlausible(raw) {
    var m = String(raw || '').match(/\d+(?:[.,]\d+)?/);
    return !!(m && toMeters(m[0]));
  }

  function pickHeight(title, value) {
    if (!value) return null;
    if (QUESTION_STRICT.test(title)) return formatHeight(value);
    if (QUESTION_LOOSE.test(title) && isPlausible(value)) return formatHeight(value);
    return null;
  }

  /* ---------- Feld bauen ---------- */
  function buildBadge(value) {
    var el = document.createElement('div');
    el.className = 'alpha-jdgm-height';
    var label = document.createElement('span');
    label.className = 'alpha-jdgm-height__label';
    label.textContent = LABEL + ':';
    var val = document.createElement('span');
    val.className = 'alpha-jdgm-height__value';
    val.textContent = value;
    el.appendChild(label);
    el.appendChild(document.createTextNode(' '));
    el.appendChild(val);
    return el;
  }

  /* ---------- Startseiten-Karussell ---------- */
  // cf_answers ist nicht dokumentiert - wir lesen es tolerant:
  // [{ question / title / cf_question: { title }, value / answer / values }]
  function answerTitle(a) {
    if (!a || typeof a !== 'object') return '';
    var q = a.cf_question || a.question || a.custom_form_question;
    if (q && typeof q === 'object') return q.title || q.name || q.label || '';
    return q || a.title || a.question_title || a.label || a.name || '';
  }

  function answerValue(a) {
    if (!a || typeof a !== 'object') return '';
    var v = a.value != null ? a.value : a.answer != null ? a.answer : a.values;
    if (Array.isArray(v)) v = v.join(', ');
    return v == null ? '' : String(v);
  }

  function heightFromAnswers(list) {
    if (!Array.isArray(list)) return null;
    for (var i = 0; i < list.length; i++) {
      var h = pickHeight(answerTitle(list[i]), answerValue(list[i]));
      if (h) return h;
    }
    return null;
  }

  var loadedUrls = {};
  function loadCarouselData() {
    if (!window.performance || !performance.getEntriesByType) return;
    performance.getEntriesByType('resource').forEach(function (entry) {
      if (entry.name.indexOf('reviews_for_carousel') === -1 || loadedUrls[entry.name]) return;
      loadedUrls[entry.name] = true;
      fetch(entry.name)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var reviews = (data && data.reviews) || [];
          reviews.forEach(function (rv) {
            var h = heightFromAnswers(rv.cf_answers);
            if (h && rv.uuid) heights[rv.uuid] = h;
          });
          decorateCarousels();
        })
        .catch(function () {});
    });
  }

  function decorateCarousels() {
    document.querySelectorAll('.jdgm-carousel-item[data-review-id]').forEach(function (card) {
      var h = heights[card.getAttribute('data-review-id')];
      var existing = card.querySelector('.alpha-jdgm-height');
      if (!h) {
        if (existing) existing.remove();
        return;
      }
      if (existing) {
        existing.querySelector('.alpha-jdgm-height__value').textContent = h;
        return;
      }
      var section = card.querySelector('.jdgm-rating-section');
      if (!section) return;
      section.insertBefore(buildBadge(h), section.firstChild);
    });
  }

  /* ---------- Produktseite ---------- */
  // Inline mit !important: Judge.me und unser CSS setzen display mit !important
  function hide(el) {
    el.style.setProperty('display', 'none', 'important');
  }

  var LABEL_LINE = /^\s*([^:]{2,60}?)\s*:\s*(.+?)\s*$/;

  function decorateReviewItems() {
    document.querySelectorAll('.jdgm-review-widget .jm-review-item').forEach(function (item) {
      if (item.querySelector('.alpha-jdgm-height')) return;
      var answers = item.querySelector('.jm-custom-answers');
      if (!answers) return;

      // Kleinstes Element, dessen Text "Frage: Antwort" ist
      var found = null;
      var candidates = answers.querySelectorAll('*');
      for (var i = candidates.length - 1; i >= 0 && !found; i--) {
        var el = candidates[i];
        var m = (el.textContent || '').replace(/\s+/g, ' ').match(LABEL_LINE);
        if (!m) continue;
        var h = pickHeight(m[1], m[2]);
        if (h) found = { el: el, value: h };
      }
      if (!found) return;

      // Das Original ausblenden; den Eintrag, nicht nur ein inneres <b>
      var entry = found.el;
      while (entry.parentElement && entry.parentElement !== answers &&
             !entry.parentElement.classList.contains('jm-stack') &&
             !entry.parentElement.classList.contains('jm-cluster')) {
        entry = entry.parentElement;
      }
      hide(entry);
      entry.classList.add('alpha-jdgm-height-source');
      var visibleLeft = Array.prototype.some.call(answers.querySelectorAll('*'), function (c) {
        return !c.closest('.alpha-jdgm-height-source') && c.children.length === 0 && c.textContent.trim();
      });
      if (!visibleLeft) hide(answers);

      // Ueber die Sterne
      var stars = item.querySelector('.jm-star-rating');
      var row = stars ? stars.closest('.jm-review-item__content > *') || stars : null;
      var content = item.querySelector('.jm-review-item__content');
      if (row && row.parentElement) {
        row.parentElement.insertBefore(buildBadge(found.value), row);
      } else if (content) {
        content.insertBefore(buildBadge(found.value), content.firstChild);
      }
    });
  }

  /* ---------- Produktseite: Slider statt Seiten ----------
   * Die Karten liegen per CSS in einer waagerechten Scroll-Leiste. Die Pfeile
   * scrollen um eine Karte; am Ende einer Judge.me-Seite klicken sie die
   * (unsichtbare) Seitennavigation von Judge.me und springen in der neuen
   * Seite an den Anfang bzw. - rueckwaerts - ans Ende. Judge.me scrollt beim
   * Seitenwechsel das Fenster zum Widget-Anfang; das unterbinden wir kurz,
   * sonst springt die Seite bei jedem Klick nach oben. */
  var ARROW_PREV = '<svg viewBox="0 0 20 34" aria-hidden="true"><path d="M16.67 33.33 0 16.67 16.67 0l2.54 2.57L5.11 16.67l14.1 14.1z"/></svg>';
  var ARROW_NEXT = '<svg viewBox="0 0 20 34" aria-hidden="true"><path d="M2.54 33.33 0 30.76l14.1-14.1L0 2.57 2.54 0l16.67 16.67z"/></svg>';
  var nativeScrollTo = window.scrollTo.bind(window);
  var pageTurn = null; // { where: 'start' | 'end', first: Element, y: Number, until: Number }

  function judgemePageButton(widget, dir) {
    var navs = widget.querySelectorAll('.jm-pagination-controls__button--nav');
    if (navs.length < 2) return null;
    var b = dir === 'prev' ? navs[0] : navs[navs.length - 1];
    if (b.disabled || b.classList.contains('jm-button--disabled')) return null;
    return b;
  }

  function sliderState(list) {
    return {
      atStart: list.scrollLeft <= 2,
      atEnd: list.scrollLeft + list.clientWidth >= list.scrollWidth - 2
    };
  }

  function muteWindowScroll(ms) {
    var w = window;
    var ep = Element.prototype;
    var orig = { to: w.scrollTo, s: w.scroll, by: w.scrollBy, into: ep.scrollIntoView };
    var noop = function () {};
    w.scrollTo = w.scroll = w.scrollBy = noop;
    ep.scrollIntoView = noop;
    setTimeout(function () {
      w.scrollTo = orig.to;
      w.scroll = orig.s;
      w.scrollBy = orig.by;
      ep.scrollIntoView = orig.into;
    }, ms);
  }

  function turnPage(list, button, where) {
    pageTurn = { where: where, first: list.firstElementChild, y: window.scrollY, until: Date.now() + 5000 };
    muteWindowScroll(1500);
    button.click();
  }

  function finishPageTurn(list) {
    if (!pageTurn) return;
    if (Date.now() > pageTurn.until) {
      pageTurn = null;
      return;
    }
    if (!list.firstElementChild || list.firstElementChild === pageTurn.first) return; // noch alte Seite
    list.style.scrollBehavior = 'auto';
    list.scrollLeft = pageTurn.where === 'start' ? 0 : list.scrollWidth;
    list.style.scrollBehavior = '';
    if (Math.abs(window.scrollY - pageTurn.y) > 2) nativeScrollTo(0, pageTurn.y);
    pageTurn = null;
  }

  function slide(widget, dir) {
    var list = widget.querySelector('.jdgm-review-list');
    if (!list) return;
    var item = list.querySelector('.jm-review-item');
    var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
    var step = item ? item.getBoundingClientRect().width + gap : list.clientWidth;
    var st = sliderState(list);
    var button;
    if (dir === 'next') {
      if (!st.atEnd) list.scrollBy({ left: step, behavior: 'smooth' });
      else if ((button = judgemePageButton(widget, 'next'))) turnPage(list, button, 'start');
    } else {
      if (!st.atStart) list.scrollBy({ left: -step, behavior: 'smooth' });
      else if ((button = judgemePageButton(widget, 'prev'))) turnPage(list, button, 'end');
    }
  }

  function updateNav(widget) {
    var list = widget.querySelector('.jdgm-review-list');
    var nav = widget.querySelector('.alpha-jdgm-nav');
    if (!list || !nav) return;
    var st = sliderState(list);
    var prev = nav.querySelector('[data-dir="prev"]');
    var next = nav.querySelector('[data-dir="next"]');
    var prevOff = st.atStart && !judgemePageButton(widget, 'prev');
    var nextOff = st.atEnd && !judgemePageButton(widget, 'next');
    if (prev.disabled !== prevOff) prev.disabled = prevOff;
    if (next.disabled !== nextOff) next.disabled = nextOff;
    // Passt alles auf einmal ins Bild: keine Pfeile
    var off = prevOff && nextOff;
    if (nav.hidden !== off) nav.hidden = off;
  }

  function setupSliders() {
    document.querySelectorAll('.jdgm-review-widget').forEach(function (widget) {
      var list = widget.querySelector('.jdgm-review-list');
      if (!list) return;

      var nav = widget.querySelector('.alpha-jdgm-nav');
      if (!nav) {
        nav = document.createElement('div');
        nav.className = 'alpha-jdgm-nav';
        nav.innerHTML =
          '<button type="button" class="alpha-jdgm-nav__btn" data-dir="prev" aria-label="Vorherige Bewertungen">' + ARROW_PREV + '</button>' +
          '<button type="button" class="alpha-jdgm-nav__btn" data-dir="next" aria-label="Weitere Bewertungen">' + ARROW_NEXT + '</button>';
        nav.addEventListener('click', function (e) {
          var b = e.target.closest('.alpha-jdgm-nav__btn');
          if (b && !b.disabled) slide(widget, b.getAttribute('data-dir'));
        });
        (list.closest('.jm-review-widget__body') || list).insertAdjacentElement('afterend', nav);
      }

      // Judge.me kann die Liste neu anlegen - dann neu anhaengen
      if (!list.alphaSlider) {
        list.alphaSlider = true;
        list.addEventListener('scroll', function () { updateNav(widget); }, { passive: true });
      }

      finishPageTurn(list);
      updateNav(widget);
    });
  }

  window.addEventListener('resize', function () {
    document.querySelectorAll('.jdgm-review-widget').forEach(updateNav);
  });

  /* ---------- Link direkt ins Bewertungsformular ----------
   * Fuer Mails ("Bewerte Deinen Kauf"): Produkt-URL + #bewertung-schreiben
   * scrollt zu den Bewertungen und oeffnet das Formular. Ohne das landet der
   * Kunde nur bei der Liste und muss den Knopf selbst suchen.
   * Das Widget baut sich nachtraeglich auf - deshalb bis zu 12 s warten. */
  var REVIEW_HASH = '#bewertung-schreiben';

  function openReviewForm() {
    if (window.location.hash.toLowerCase() !== REVIEW_HASH) return;
    var tries = 0;
    (function attempt() {
      var widget = document.querySelector('.jdgm-review-widget');
      // neues Widget (jm-*), als Rueckfall die Klasse des alten Widgets
      var button = widget && widget.querySelector('.jm-action-buttons__button, .jdgm-write-rev-link');
      if (button) {
        widget.scrollIntoView({ block: 'start' });
        // kurz warten: Judge.me haengt den Klick erst nach dem Aufbau an
        setTimeout(function () { button.click(); }, 400);
      } else if (tries++ < 40) {
        setTimeout(attempt, 300);
      }
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openReviewForm);
  } else {
    openReviewForm();
  }
  window.addEventListener('hashchange', openReviewForm);

  /* ---------- Beobachten ---------- */
  var queued = false;
  function run() {
    queued = false;
    if (document.querySelector('.jdgm-carousel-item')) {
      loadCarouselData();
      decorateCarousels();
    }
    decorateReviewItems();
    setupSliders();
  }
  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(run);
  }

  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var t = records[i].target;
      // eigene Aenderungen und die Karussell-Animation ignorieren
      if (records[i].type === 'childList' && !(t.closest && t.closest('.alpha-jdgm-height'))) {
        schedule();
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  // Fuer Tests im Browser: alphaJudgeme.heights['<uuid>'] = '1,94 m'; alphaJudgeme.refresh()
  window.alphaJudgeme = { heights: heights, refresh: schedule, formatHeight: formatHeight };
})();
/* ONF-CUSTOM-END :: alpha_judgeme */
